var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDepositIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9994 2.44195L4.97852 9.094L22.2662 10.6131L18.9626 3.35922C18.4478 2.22892 17.0627 1.80014 15.9994 2.44195Z",
    fill: "#0A0C13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.31109 23.4004C2.65898 25.3761 4.23894 26.9636 6.22227 27.2645C8.19159 27.5633 9.96989 27.8566 12.7011 27.8566C15.4323 27.8566 17.2106 27.5633 19.1799 27.2645C21.1633 26.9636 22.7432 25.3761 23.0911 23.4004C23.3595 21.8761 23.6044 20.5525 23.6044 17.9918C23.6044 15.4311 23.3595 14.1074 23.0911 12.5832C22.7432 10.6075 21.1633 9.02002 19.1799 8.71911C17.2106 8.42033 15.4323 8.12695 12.7011 8.12695C9.96989 8.12695 8.1916 8.42033 6.22227 8.71911C4.23894 9.02002 2.65898 10.6075 2.31109 12.5832C2.04267 14.1074 1.79785 15.4311 1.79785 17.9918C1.79785 20.5525 2.04267 21.8761 2.31109 23.4004Z",
    fill: "#1D202B",
    stroke: "#585C6B",
    strokeWidth: 3.21429
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0589 21.0039H17.8945C16.174 21.0039 14.7793 19.6091 14.7793 17.8887C14.7793 16.1682 16.174 14.7734 17.8945 14.7734H24.0589C25.2424 14.7734 26.2018 15.7328 26.2018 16.9163V18.861C26.2018 20.0445 25.2424 21.0039 24.0589 21.0039Z",
    fill: "#0A0C13",
    stroke: "#585C6B",
    strokeWidth: 3.21429,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97852 9.094L15.9994 2.44195C17.0627 1.80014 18.4478 2.22892 18.9626 3.35922L22.2662 10.6131",
    stroke: "#585C6B",
    strokeWidth: 3.21429,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepositIcon);
export default __webpack_public_path__ + "static/media/depositIcon.918349f906017028a334e8fd93d068d5.svg";
export { ForwardRef as ReactComponent };